import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { AssignEntitiesEnum } from 'Common/FieldEnum';
import { SiteGroupGridContainer } from '../../containers/assignEntities/SiteGroupGridContainer';
import { ItemGridContainer } from '../../containers/assignEntities/ItemGridContainer';

const AssignSiteGroupToItemsComponent = props => {
  const {
    allItemsData,
    loadingAllItems,
    siteGroupData,
    loadingSiteGroup,
    setIsReadOnlyState,
    isReadOnly,
    setItemGridInstance,
    rightSideGridReactTableRef,
    onResetPageOnDataChange,
    onFilteredChange,
    isRightGridFiltered,
    direction,
    resetGridPage,
  } = props;

  return (
    <Grid>
      <Grid.Row columns={2}>
        <Grid.Column width={6}>
          <Field
            component={SiteGroupGridContainer}
            name={AssignEntitiesEnum.SiteGroupGridInfo}
            {...{
              dataSource: siteGroupData,
              loadingSiteGroup,
              isLeftSideSiteGroupGrid: true,
              isRightSideItemGrid: true,
              setIsReadOnlyState,
              isReadOnly,
              onResetPageOnDataChange,
              direction,
              resetGridPage,
            }}
          />
        </Grid.Column>
        <Grid.Column width={10}>
          <Field
            component={ItemGridContainer}
            name={AssignEntitiesEnum.ItemGridInfo}
            {...{
              dataSource: allItemsData,
              loadingAllItems,
              isRightSideItemGrid: true,
              onResetPageOnDataChange,
              setIsReadOnlyState,
              isReadOnly,
              setItemGridInstance,
              onFilteredChange,
              rightSideGridReactTableRef,
              isRightGridFiltered,
              direction,
              resetGridPage,
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

AssignSiteGroupToItemsComponent.propTypes = {
  allItemsData: PropTypes.array.isRequired,
  siteGroupData: PropTypes.array.isRequired,
  resetGridPage: PropTypes.object.isRequired,
  setIsReadOnlyState: PropTypes.func,
  onResetPageOnDataChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
  setItemGridInstance: PropTypes.func,
  isReadOnly: PropTypes.bool,
  direction: PropTypes.bool,
  loadingAllItems: PropTypes.bool,
  loadingSiteGroup: PropTypes.bool,
  rightSideGridReactTableRef: PropTypes.object,
  isRightGridFiltered: PropTypes.bool,
};

AssignSiteGroupToItemsComponent.defaultProps = {
  loadingAllItems: false,
  loadingSiteGroup: false,
  isRightGridFiltered: false,
  isReadOnly: true,
  direction: true,
  rightSideGridReactTableRef: null,
  setItemGridInstance: () => {},
  setIsReadOnlyState: () => {},
  onResetPageOnDataChange: () => {},
  onFilteredChange: () => {},
};
export default AssignSiteGroupToItemsComponent;



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/components/assignEntities/AssignSiteGroupsToItems.js